import { motion } from "framer-motion";

/**
 * Mono uppercase HUD section eyebrow — "§ Section Label" style.
 * Replaces the prior decorative dashed eyebrow with the brutalist
 * letter-spaced overline used across the IW HUD aesthetic.
 */
export function SectionEyebrow({ children, className = "" }) {
  return (
    <div className={`iw-overline mb-3 ${className}`}>
      {children}
    </div>
  );
}

/** Brutalist section title — Orbitron display, tight tracking, navy. */
export function SectionTitle({ children, className = "" }) {
  return (
    <h2
      className={`font-display font-bold tracking-tight text-balance leading-[1.04]
                  text-[clamp(2.25rem,5.5vw,4rem)] text-primary ${className}`}
    >
      {children}
    </h2>
  );
}

export function SectionLead({ children, className = "" }) {
  return (
    <p className={`text-lg md:text-xl text-foreground/75 leading-relaxed text-pretty max-w-3xl mx-auto ${className}`}>
      {children}
    </p>
  );
}

export function FadeUp({ children, delay = 0, className = "", as = "div", ...rest }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y: 22 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}

/** Sharp HUD divider — thin border with a centered accent square. */
export function HRule({ className = "" }) {
  return (
    <div className={`flex items-center justify-center my-14 md:my-16 ${className}`}>
      <div className="flex items-center gap-3">
        <span className="h-px w-16 md:w-24 bg-border" />
        <span className="block h-1.5 w-1.5 bg-accent" />
        <span className="h-px w-16 md:w-24 bg-border" />
      </div>
    </div>
  );
}
